import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  RouteLocationNormalized,
  NavigationGuardNext
} from 'vue-router'
import { inject } from 'vue'
import ControlPanel from '@/views/ControlPanel.vue'
import ControlPanelChildRoutes from '@/router/controlPanel'
import { PublicClientApplication } from '@azure/msal-browser'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/redirect-msal',
    name: 'redirect-msal',
    component: () => import('@/views/auth/Redirect.vue')
  },
  {
    path: '/signOut',
    name: 'signOut',
    component: () => import('@/views/auth/SignOut.vue')
  },
  {
    path: '/cp',
    name: 'control-panel',
    component: ControlPanel,
    children: ControlPanelChildRoutes,
    redirect: () => {
      if (window.innerWidth < 768) {
        return { name: 'control-panel.projects.list' };
      }
      return { name: 'map.projects' };
    },
    beforeEnter: async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      const msal: PublicClientApplication | undefined = inject('msal')

      if (!msal) {
        console.error('MSAL instance is not available in router');
        next({ name: 'home' });
        return;
      }

      console.info('Initializing MSAL in router');
      await msal.initialize(); // Ensure MSAL is initialized

      const isAuthenticated = !!msal?.getAllAccounts().length;
      if (to.name !== 'home' && !isAuthenticated) next({ name: 'home' });
      else next();
    },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: (to: any, from: any, savedPosition: any) => {
    if (savedPosition) return savedPosition
    // Table filters, sorting and pagination only update the query string.
    if (to.path === from.path) return false
    return { top: 0, left: 0 }
  }
})

router.onError(async (error, to) => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      window.location.assign(to.fullPath);
    } catch (cacheError) {
      console.error('Error clearing caches:', cacheError);
      window.location.assign(to.fullPath);
    }
  }
});

export default router;
